import type { passwordInputType } from 'portal/src/components/common/forms/FormFieldTypes';

export const getFields = () => {
  const formFieldsConfiguration: passwordInputType[] = [
    {
      name: 'newPassword',
      label: 'New Password',
      placeholder: 'Enter your new password',
      required: true,
      type: 'password',
    },
    {
      name: 'confirmPassword',
      placeholder: 'Confirm your new password',
      label: 'Confirm Password',
      required: true,
      type: 'password',
    },
  ];
  return formFieldsConfiguration;
};
